import { AttachmentFile, CloudFile } from 'owa-attachment-file-types';
import { ShareAttachmentProperties } from 'owa-attachment-well-data';
import { action } from 'satcheljs';
import { InsertLinkFailureType } from '../types/InsertLinkFailureType';

export const addInsertLinkViewState = action(
    'ADD_INSERT_LINK_VIEW_STATE',
    (
        linkId: string,
        file: AttachmentFile,
        upsellProperties: ShareAttachmentProperties,
        displayText: string
    ) => ({
        linkId: linkId,
        file: file,
        upsellProperties: upsellProperties,
        displayText: displayText,
    })
);

export const removeInsertLinkViewState = action(
    'REMOVE_INSERT_LINK_VIEW_STATE',
    (linkId: string) => ({
        linkId: linkId,
    })
);

export const onUploadDone = action('ON_UPLOAD_DONE', (linkId: string, file: CloudFile) => ({
    linkId: linkId,
    file: file,
}));

export const onSharingLinkRetrivalFailure = action(
    'ON_SHARING_LINK_RETRIVAL_FAILURE',
    (linkId: string, insertLinkFailureType: InsertLinkFailureType) => ({
        linkId: linkId,
        insertLinkFailureType: insertLinkFailureType,
    })
);

export const onStartRetrievingSharingLink = action(
    'ON_START_RETRIEVING_SHARING_LINK',
    (linkId: string) => ({
        linkId: linkId,
    })
);
